export default "__VITE_ASSET__DOByqDgY__"